import { format, parseISO } from "date-fns";
import { CalendarBlank } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// Sep 18 2026, user's explicit ask ("date format for the user readable
// dd-mm-yyyy currently mm/dd/yyyy") - a native <input type="date">'s
// displayed format is controlled entirely by the browser/OS locale, not
// by this app, so it silently showed mm/dd/yyyy in the user's browser.
// Swapped to this Popover+Calendar combo (react-day-picker, already used
// elsewhere in the app) so the display format is always explicitly
// dd-mm-yyyy regardless of the user's browser locale - the underlying
// value stays the same yyyy-mm-dd ISO string the rest of the app/API
// already expects, only how it's shown changes.
// Oct 13 2026, extracted out of GrnApprovalPage.jsx (where this was
// first built) into a shared component so the same fix could be reused
// on /admin/act-as-supplier's date filter without duplicating it -
// `disabledMatcher` is an optional react-day-picker `disabled` matcher
// (e.g. `(date) => date > parseISO(toDate)`) for min/max range pairs.
export function DateField({ value, onChange, testId, disabledMatcher, className = "" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={`w-full h-9 justify-start rounded-sm border-[#D0D5DD] mt-1 font-normal text-[13px] ${className}`}
          data-testid={testId}
        >
          <CalendarBlank size={14} className="mr-2 text-[#475467]" />
          {value ? format(parseISO(value), "dd-MM-yyyy") : <span className="text-[#98A2B3]">dd-mm-yyyy</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value ? parseISO(value) : undefined}
          defaultMonth={value ? parseISO(value) : undefined}
          onSelect={(d) => d && onChange(format(d, "yyyy-MM-dd"))}
          disabled={disabledMatcher}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
